import type { TFunction } from 'i18next';

import yup from '../../shared/validation';

export interface IContactFormValues {
  name: string;
  email: string;
  subject: string;
  message: string;
}

export const CONTACT_FORM_INITIAL_VALUES: IContactFormValues = {
  name: '',
  email: '',
  subject: '',
  message: '',
};

export function getContactFormValidation(t: TFunction) {
  return yup.object({
    name: yup
      .string()
      .trim()
      .max(200, t('formikValidation.maxLength').replace('{0}', '200'))
      .required(t('formikValidation.nameRequired')),
    email: yup
      .string()
      .trim()
      .max(254, t('formikValidation.maxLength').replace('{0}', '254'))
      .email(t('formikValidation.emailCorrect'))
      .required(t('formikValidation.emailRequired')),
    subject: yup
      .string()
      .trim()
      .max(200, t('formikValidation.maxLength').replace('{0}', '200'))
      .required(t('contacts.validation.subjectRequired')),
    message: yup
      .string()
      .trim()
      .min(5, t('contacts.validation.messageMin').replace('{0}', '5'))
      .max(8000, t('formikValidation.maxLength').replace('{0}', '8000'))
      .required(t('contacts.validation.messageRequired')),
  });
}
